import {useState,useContext,useEffect} from 'react';
import {QuestionAnswers} from '../context';


const operators = {
  '+' : (a,b) => a + b,
  '-' : (a,b) => a - b,
  '=' : (a,b) => a === b,
  '<' : (a,b) => a < b,
  '>' : (a,b) => a > b
};

// keyIndex is -S0, -S1, -P0, -P1 ...
export const useSectionCompleted = (sectionQuestions, keyIndex) => {
  const questionAnswers = useContext(QuestionAnswers);
  const [sectionComplete,setSectionComplete] = useState(false);

  useEffect(() => {
    const hasAllRequiredAnswers = sectionQuestions.reduce((bool,item) => {
      const answer = questionAnswers[item.key];
      if (!item.condition) {
        if (answer) {
          return bool;
        }
        return false;
      } else {
        const {lhs,operator:o,rhs} = item.condition;
        const parentAnswer = questionAnswers[`${lhs}${keyIndex}`];
        if (parentAnswer) {
          const conditionMet = operators[o](parentAnswer,rhs);
          if (conditionMet && !answer) {
            return false;
          }
        }
        return bool;
      }
    },true);

    setSectionComplete(hasAllRequiredAnswers);

  },[questionAnswers, sectionQuestions, keyIndex]);

  return sectionComplete;
  
};